/** localStorage helpers that never throw (private mode, quota, disabled storage). */
export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function save(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable: the app keeps working in memory */
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export const KEYS = {
  matches: 'rang:matches',
  queue: 'rang:queue',
  tokens: 'rang:tokens',
  recent: 'rang:recent',
  players: 'rang:players',
  lastPlayers: 'rang:lastPlayers',
  teams: 'rang:teams',
  draft: 'rang:draft',
  presetNames: 'rang:presetNames',
  muted: 'rang:muted',
  voice: 'rang:voice',
  voiceName: 'rang:voiceName',
  roomClients: 'rang:roomClients',
  roomHosts: 'rang:roomHosts',
} as const;
